import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-timetable-leg.scss',
  tag: 'paf-result-timetable-leg',
})

export class PafResultTimetableLeg implements ComponentInterface {

  /**
   * The visually hidden heading
   */
  @Prop() public heading!: string;

  /**
   * The heading level for the summary
   */
  @Prop() public headingLevel!: number;

  /**
   * The screenreader summary of the
   * departure details
   */
  @Prop() public summaryDeparture!: string;

  /**
   * The screenreader summary of the
   * departure details
   */
  @Prop() public summaryArrival!: string;

  public render(): HTMLDivElement {
    const HEADING_TAG = `h${this.headingLevel}`;

    return (
      <section>
        <div
          class='timetable-leg-a11y'
        >
          <HEADING_TAG data-testid='hidden-title'>{this.heading}</HEADING_TAG>
          <p data-testid='hidden-departure'>{this.summaryDeparture}</p>
          <p data-testid='hidden-arrival'>{this.summaryArrival}</p>
        </div>
        <div
          aria-hidden='true'
          class='timetable-leg'
          role='presentation'
        >
          {/* Times Column */}
          <div
            class='timetable-leg__times'
          >
            <slot name='departure-time'/>
            <slot name='arrival-time'/>
          </div>
          {/* Pearl Chain Column */}
          <div
            class='timetable-leg__pearl_chain'
          >
            <slot name='pearl-chain'/>
          </div>
          {/* Details Column */}
          <div
            class='timetable-leg__details'
          >
            {/* Departure Block */}
            <div class='timetable-leg__details_departure'>
              <slot name='station-and-platform-departure' />
              <slot name='wheelchair-info-departure'/>
              <slot name='service'/>
              <div class='timetable-leg__attributes_and_utilization'>
                <slot name='utilization'/>
                <slot name='attributes'/>
              </div>
              <slot name='cus-him-inline'/>
            </div>
            {/* Arrival Block */}
            <div class='timetable-leg__details_arrival'>
              <slot name='station-and-platform-arrival' />
              <slot name='wheelchair-info-arrival'/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
